export default __webpack_public_path__ + "static/image-entertainment-cf6c2ad978ee2c1ab07ebcec4834de61.png";